import { X } from 'lucide-react';

import type { Role } from '@/modules/auth/roles';
import { Badge } from '@/modules/ui/components/badge/Badge';
import { ConfirmDeleteDialog } from '@/modules/ui/components/confirm-delete-dialog/ConfirmDeleteDialog';
import type { UserApi } from '@/modules/users/types';

interface RoleBadgeProps {
  role: Role;
  user: UserApi;
  onRemove: (userId: string, role: Role) => void;
}

export const RoleBadge = ({ role, user, onRemove }: RoleBadgeProps) => {
  return (
    <Badge variant="secondary" className="gap-1 pr-1">
      {role}
      <ConfirmDeleteDialog
        title="Remove Role"
        description={`Are you sure you want to remove the role "${role}" from ${user.firstName} ${user.lastName}?`}
        onDelete={() => onRemove(user.id, role)}
        trigger={
          <div
            role="button"
            className="hover:bg-destructive/20 hover:text-destructive rounded-full p-0.5 transition-colors"
          >
            <X size={12} />
          </div>
        }
      />
    </Badge>
  );
};
